import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F8916Service {
  private defaultsSaveUrl: string;

  constructor(private http: HttpClient) {
    this.defaultsSaveUrl = "/saveJsonObject?action_code=z9frws";
  }

  save8916Form(base_url: string, mainData: any, rowData: any, globalService: any, filterParams: any = {}): Observable<any> {
    // Use filter parameters passed from component (replaces workspaceFactory.activeScreen.filters.getFilterParams())

    const jsonSettings = {
      "tax_year": rowData.TAX_YEAR || filterParams.tax_year || '',
      "scenario": rowData.SCENARIO || filterParams.scenario || "",
      "jcd_key": rowData.JCD_KEY || filterParams.jcd_key || "",
      "combination_key": rowData.COMBINATION_KEY || filterParams.combination_key || '',
      "trans_type_key": mainData[0].editrows[0][0].trans_type_key,
      "scenarioCode": rowData.SCENARIO_CODE || filterParams.scenarioCode || rowData.SCENARIO || filterParams.scenario || "",
      "is_issue_key_enabled": filterParams.is_issue_key_enabled || "N",
      "screen_key": globalService?.globalParams?.screen_key || filterParams.screen_key || "",
      "activity_key": globalService?.globalParams?.activity_key || filterParams.activity_key || "",
      "screen_type": filterParams.screen_type || "custom-tab",
      "is_locked": filterParams.is_locked || "N",
      "process_name": "F1120_8916"
    };

    const jsonObj = JSON.stringify(mainData);
    const jsonSettingsStr = JSON.stringify(jsonSettings);

    let params = _.merge({}, globalService.globalParams, filterParams);
    params = _.extend({ jsonObj: jsonObj }, params);
    params = _.extend({ jsonSettings: jsonSettingsStr }, params);
    params.process_name = 'F1120_8916';
    params.combination_key = rowData.COMBINATION_KEY;
    params.trans_type_key = mainData[0].editrows[0][0].trans_type_key;
    params.tax_year = rowData.TAX_YEAR || filterParams.tax_year || '';
    params.scenario = rowData.SCENARIO || filterParams.scenario || "";
    params.jcd_key = rowData.JCD_KEY || filterParams.jcd_key || "";
    params.scenarioCode = rowData.SCENARIO_CODE || filterParams.scenarioCode || rowData.SCENARIO || filterParams.scenario || "";
    params.is_issue_key_enabled = filterParams.is_issue_key_enabled || "N";
    params.screen_key = globalService?.globalParams?.screen_key || filterParams.screen_key || "";
    params.activity_key = globalService?.globalParams?.activity_key || filterParams.activity_key || "";
    params.screen_type = filterParams.screen_type || "custom-tab";
    params.is_locked = filterParams.is_locked || "N";

    // Add checkLockedbj for lock checking
    const checkLockedbj = [{
      "leid": rowData.LEID || rowData.SOURCE_LEID || "",
      "consol_group_key": String(rowData.CONSOL_GROUP_KEY || "1"),
      "combination_key": String(rowData.COMBINATION_KEY || filterParams.combination_key || "")
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Convert params to URLSearchParams for form-urlencoded format (like AngularJS)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post(base_url + this.defaultsSaveUrl, urlEncoded.toString(), httpOptions).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
} 